export default {
    "title": "🇨🇿 Čeština",

    "首页": "Domů",
    "关于": "O nás",
    "会员": "Členství",
    "推荐计划": "Program doporučení",
    "个人": "Profil",
    "推荐": "Doporučení",
    "预订": "Vyhledat nyní",
    "事件": "Událost",
    "登出": "Odhlásit se",
    "登录": "Přihlásit se",
    "注册": "Registrovat",
    "我们的应用程序现在可用": "Naše aplikace je nyní dostupná",
    "为了获得更好的体验，我们刚刚推出了移动应用程序，以实现无缝、更快的预订。": "Pro lepší zážitek jsme právě spustili naše mobilní aplikace pro bezproblémové a rychlejší rezervace.",
    "iOS版下载（即将推出）": "Stáhnout pro iOS (Již brzy)",
    "Android版下载（即将推出）": "Stáhnout pro Android (Již brzy)",
    "为什么选择我们": "Proč si vybrat nás",
    "我们卓越的服务。": "Naše vynikající služby.",
    "收入最高的酒店": "Nejoblíbenější nemovitosti",
    "我们的合作酒店收入最高。": "Naše spolupráce zahrnuje nejziskovější projekty v oblasti nemovitostí.",
    "回报": "Výnosy",
    "最具特色的酒店": "Nemovitosti se speciálními funkcemi",
    "我们平台上最有特色的酒店。": "Nejvíce doporučované nemovitosti na naší platformě",
    "热门国家和目的地": "Odemkněte exkluzivní nabídky v nejlepších realitních místech Kanady!",
    "从我们的合作伙伴和朋友那里了解一些来自城市各地的最佳提示。": "Nejlepší městské lokality doporučené odborníky a zasvěcenci.",
    "酒店": "Nemovitost",
    "预订酒店并开始赚取": "Přehled kanadského trhu s nemovitostmi!",
    "让我们开始与TitanTraveler一起探索世界": "Transparentní data Ověřené nabídky Skutečné příležitosti.",
    "客户评价": "Reference",
    "查看我们用户的真实评价。": "Podívejte se na naše autentické reference od našich uživatelů.",
    "银行卡列表": "Seznam bankovních karet",
    "银行列表": "Seznam bank",
    "持卡人姓名": "Jméno držitele karty",
    "银行卡号": "Bankovní účet",
    "支付密码": "Platební heslo",
    "提交": "Odeslat",
    "Pix列表": "Seznam Pix",
    "Pix类型": "Typ Pix",
    "Pix账号": "Účet Pix",
    "账号列表": "Seznam účtů",
    "网络": "Síť",
    "地址": "Adresa",
    "备注": "Poznámka",
    "充值金额": "Částka dobití",
    "支付类型": "Typ platby",
    "支付银行": "Platební banka",
    "USDT地址": "USDT adresa",
    "二维码": "QR kód",
    "充值渠道": "Kanál dobití",
    "充值凭证": "Poukaz na dobití",
    "立即登录": "Přihlásit se nyní",
    "用户名": "Uživatelské jméno",
    "密码": "Heslo",
    "邀请码": "Kód pozvánky",
    "确认密码": "Potvrdit heslo",
    "手机": "Mobil",
    "注册2": "Zaregistrovat se",
    "金额": "Částka",
    "新增": "Nový",
    "我们的精彩": "Náš úžasný",
    "故事": "Příběh",
    "奖项": "Ocenění",
    "获得": "Získáno",
    "钱包余额": "Zůstatek peněženky",
    "今日奖励": "Dnešní odměny",
    "总行程": "Celková nemovitost",
    "访问行程": "Navštívená nemovitost",
    "酒店历史": "Historie nemovitostí",
    "单价": "Cena",
    "数量": "Počet",
    "总额": "Celkem",
    "奖励": "Odměny",
    "上一页": "Předchozí",
    "下一页": "Další",
    "每套预订量": "Rezervace na sadu",
    "预订奖励": "Odměna za rezervaci",
    "每日预订": "Denní rezervace",
    "手机号码": "Telefonní číslo",
    "修改密码": "Změnit heslo",
    "登录密码": "Přihlašovací heslo",
    "当前密码": "Aktuální heslo",
    "新密码": "Nové heslo",
    "确认新密码": "Potvrdit nové heslo",
    "保存修改": "Uložit změny",
    "充值": "Dobít",
    "我们的": "Naše",
    "复制": "Kopírovat",
    "分享链接": "Sdílet odkaz",
    "搜索酒店": "Vyhledat nemovitost",
    "实际等级": "Skutečná úroveň",
    "升级": "Upgradovat",
    "已完成预订": "Celková nemovitost",
    "登录时间": "Čas přihlášení",
    "信誉分": "Důvěryhodnost",
    "控制菜单": "Menu panelu",
    "提现": "Vybrat",
    "提现账号": "Účet pro výběr",
    "你确定要删除此账号吗": "Opravdu chcete tento účet smazat",
    "你确定要删除此地址吗": "Opravdu chcete tuto adresu smazat",
    "提示": "Tipy",
    "是": "Ano",
    "否": "Ne",
    "全部": "Vše",
    "待处理": "Nevyřízeno",
    "冻结中": "Zmrazeno",
    "已完成": "Dokončeno",
    "订阅": "Přihlásit se k odběru",
    "希望在我们推出新模板或更新时收到通知。 只需注册，我们就会通过电子邮件向您发送通知。": "Chcete být upozorněni, když spustíme novou šablonu nebo aktualizaci. Stačí se zaregistrovat a my vám pošleme oznámení e-mailem.",
    "我们的伙伴": "Naši partneři",
    "关于我们": "O NÁS",
    "实时聊天支持": "Podpora živého chatu",
    "在线聊天": "Živý chat",
    "创建时间": "Čas vytvoření",
    "你确定要登出当前账号吗？": "Chcete se odhlásit?",
    "请输入你的邮箱": "Zadejte svůj e-mail",
    "好评": "Velmi dobré",
    "条评论": "Recenze",
    "平均每晚": "Průměr/noc",
    "旅行旅程": "Podrobnosti o nemovitosti",
    "正在寻找酒店": "Hledání další nemovitosti",
    "开始预订": "Start",
    "旅程价格": "Cena nemovitosti",
    "佣金": "Provize",
    "底部-about": "Jsme realitní agentura se sídlem v Torontu, Ontario, Kanada, která se věnuje propagaci nemovitostí v celé Kanadě prostřednictvím inovativních strategií založených na datech. S personalizovaným servisem a progresivním, růstově orientovaným myšlením pomáháme realitním firmám dosahovat úspěchu. Ať už potřebujete podporu pro zrychlení růstu společnosti, design nemovitostí, správu nemovitostí, strategické plánování nebo budoucí projekty rozvoje nemovitostí, Zoocasa Real Estate má odborné znalosti a rozsáhlé zkušenosti, které vám pomohou dosáhnout optimálních výsledků v tomto světě zaměřeném na výsledky.",
    "立即预订": "Rezervovat nyní",
    "搜索": "Vyhledat",
    "快乐的客户": "Spokojený klient",
    "快乐的酒店老板": "Spokojený majitel hotelu",
    "评论1": "Nemovitost v prestižní lokalitě — Užijte si pohodlí města, ideální pro bydlení nebo investici!",
    "评论2": "Jen 5 minut do metra — Snadné dojíždění, časově úsporné a vysoce efektivní bydlení!",
    "评论3": "Plně vybavené okolí — Nákupní centra, špičkové školy a nemocnice vše na dosah!",
    "评论4": "Svěží zelené prostředí — Komunita s nízkou hustotou, vaše klidné útočiště ve městě!",
    "评论5": "Vysoké patro s otevřeným výhledem — Neomezený výhled na obzor, užijte si východ a západ slunce každý den!",
    "评论6": "Chytrý layout — Světlý a vzdušný s orientací sever-jih, pohodlí v každém koutě!",
    "评论7": "Špičková školní čtvrť — Dejte svému dítěti náskok s vynikajícími vzdělávacími zdroji!",
    "评论8": "Renomovaná správa nemovitostí — 24/7 zabezpečení, chytrý přístupový systém a klid v duši!",
    "评论9": "Připraveno k nastěhování — Vysoce kvalitní povrchové úpravy, plně zrekonstruováno, bezstarostné vlastnictví!",
    "评论10": "Budoucí růstová zóna — Probíhá obnova oblasti, vynikající dlouhodobá hodnota!",
    "评论11": "Více funkcí za stejnou cenu — Výjimečná hodnota, vaše chytrá volba nemovitosti!",
    "评论12": "Vzácná příležitost — Omezené zásoby, zajistěte si prémiové aktivum, než bude pryč!",
    "评论13": "Byl to jiný zážitek a bylo to skvělé, místní byli velmi přátelští a zdvořilí!",
    "推荐计划1": "Uživatelé platformy mohou prostřednictvím doporučovacích kódů pozvat ostatní, aby se stali agenty platformy a stali se vaší downline.",
    "推荐计划2": "Jako upline můžete získat určité procento zisku vaší downline a zisk získaný upline bude přímo vrácen na účet platformy upline nebo do týmové zprávy.",
    "推荐计划3": "Poznámka: Všichni agenti / downlines platformy obdrží odpovídající procento ze zisku a odměn platformy, rozvoj týmu neovlivňuje zisky a odměny žádného agenta ani downlines.",
    "评分": "Hodnocení",
    "评论": "Komentář",
    "酒店很棒": "Hotel je skvělý",
    "终于体验了，酒店非常好": "Konečně jsem to zažil, hotel je velmi dobrý",
    "我对酒店非常满意并推荐预订": "Jsem s hotelem velmi spokojený a doporučuji rezervaci",
    "我很高兴很满意，价格实惠": "Jsem velmi šťastný a spokojený, cena je dostupná",
    "服务非常好，我非常喜欢": "Služba je velmi dobrá, moc se mi to líbí",
    "体验很不错，朋友已经第二次预订了": "Zkušenost byla velmi dobrá, můj přítel si to už rezervoval podruhé",
    "酒店环境优美": "Krásné hotelové prostředí",
    "酒店卫生干净": "Hotel je hygienický a čistý",
    "工作人员态度非常好": "Postoj personálu je velmi dobrý",
    "酒店服务很棒": "Hotelové služby jsou skvělé",
    "你还没有设置支付密码，请前往设置": "Nenastavili jste platební heslo, přejděte prosím do nastavení",
    "订单": "Objednávky",
    "复制成功": "Kopírování úspěšné",
    "团队与条件": "Podmínky a ujednání",
    "站内信": "Zprávy na webu",
    "请联系客服升级会员": "Pro upgrade členství kontaktujte prosím zákaznický servis",
    "我已阅读并同意": "Přečetl jsem si a souhlasím s",
    "注册协议": "Registrační smlouva",
    "忘记密码": "Zapomenuté heslo",
    "账户明细": "Podrobnosti účtu",
    "时间": "Čas",
    "类型": "Typ",
    "代理支持": "Podpora agenta",
    "冻结金额": "Zmrazená částka",
}

